import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

const ColorEdit = () => {
  const users = {
    color_name: "",
    code: "",   
    status: "",
  };

  const [ColorEditUser, setColorEditUser] = useState(users);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPedagogyData = async () => {
      try {
        const response = await axios.post(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_color_by_id",
          {
            color_id: id,
          }
        );
        setColorEditUser(response.data.data);
      } catch (error) {
        console.error("Error fetching Pedagogy data!", error);
      }
    };

    fetchPedagogyData();
  }, [id]);

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setColorEditUser({ ...ColorEditUser, [name]: value });
  };

  const submitForm = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/update_color",
        {
          color_id: id,
          ...ColorEditUser,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

    
        toast.success(response.data.message || "Data Updated Successfully!");
        navigate("/color-list");

    } catch (error) {
      console.error(
        "There was an error!",
        error.response?.data || error.message
      );
      toast.error("Something went wrong!");
    }
  };

  return (
    <div className="page-content">
      {/* Start Container Fluid */}
      <div className="container-fluid">
        {/* ========== Page Title Start ========== */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Color Edit</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript: void(0);">Color</a>
                </li>
                <li className="breadcrumb-item active">Color Edit</li>
              </ol>
            </div>
          </div>
        </div>
        {/* ========== Page Title End ========== */}
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Edit Color</h4>
              </div>
              <form onSubmit={submitForm}>
                <div className="card-body">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label
                          htmlFor="color_name"
                          className="form-label text-dark"
                        >
                          Color Name
                        </label>
                        <input
                          type="text"
                          id="color_name"
                          name="color_name"
                          className="form-control"
                          placeholder="Enter Name"
                          value={ColorEditUser.color_name}
                          onChange={changeHandler}
                        />
                      </div>
                    </div>
                    <div className="mb-3">
                    <label className="form-label">Color Code</label>
                    <input
                      type="color"
                      className="form-control form-control-color"
                      value={ColorEditUser.code}   // FIXED
                      name='code'              // FIXED
                      onChange={changeHandler}
                      required
                    />
                  </div>

                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="status" className="form-label">
                          Status
                        </label>
                        <select
                          className="form-control"
                          id="status"
                          name="status"
                          value={ColorEditUser.status}
                          onChange={changeHandler}
                          required
                        >
                          <option value="">Select Status</option>
                          <option value="Active">Active</option>
                          <option value="InActive">InActive</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer border-top">
                  <button type="submit" className="btn btn-primary">
                    Edit Change
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* End Container Fluid */}
      {/* Footer */}
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              © Venton. Crafted by{" "}
              <iconify-icon
                icon="iconamoon:heart-duotone"
                className="fs-18 align-middle text-danger"
              />{" "}
              <Link to="#" className="fw-bold footer-text" target="_blank">
                Techzaa
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ColorEdit;
